<template>
  <FormSearchableSelect
    :value="value"
    @input="$emit('input', $event)"
    :options="inventoryBinLookup"
    :placeholder="placeholder"
    :field="field"
    :note="note"
    :dropdownAutoWidth="true"
    :loading="loading"
    selectedDisplayKey="code"
  />
</template>


<script>
import FormMixin from '@/mixins/form'

export default {
  name: 'FormInventoryBinSelect',
  mixins: [FormMixin],
  props: {
    value: [Number, String],
    placeholder: String,
    field: String,
    note: String,
    accountLocationId: Number,
    defaultLabelType: String,
    inventoryBinIdFilter: Array
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      inventoryBinLookup: []
    }
  },
  watch: {
    accountLocationId: function() {
      this.requestData()
    }
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      this.loading = true
      this.loadingError = ''

      var params = {}
      if(this.accountLocationId)
        params.filter = { accountLocationId: this.accountLocationId }

      this.$apiService.inventoryService.getInventoryBinList(params)
      .then(response => {
        
        this.inventoryBinLookup = response.data
        .filter(inventoryBin => {
          if(!inventoryBin.isActive)
            return false

          // If filter set & bin not in the list, ignore it
          if(this.inventoryBinIdFilter) {
            if(!this.inventoryBinIdFilter.includes(inventoryBin.id))
              return false
          }

          return true
        })
        .map(inventoryBin => {
          return {
            value: inventoryBin.id,
            name: inventoryBin.code + (inventoryBin.accountLocationName ? ` | ${inventoryBin.accountLocationName}` : ''),
            code: inventoryBin.code,
            labelList: inventoryBin.labelList
          }
        })

        var defaultBin = null

        if(this.defaultLabelType && this.inventoryBinLookup.length > 0) {
          defaultBin = this.inventoryBinLookup.find(inventoryBin => {
            if(inventoryBin.labelList && inventoryBin.labelList.some(label => label.isFixed && label.statusType == this.defaultLabelType))
              return true
            return false
          })
        }
        if(!defaultBin)
          defaultBin = this.inventoryBinLookup[0]

        // If value not set, use default
        this.$nextTick(() => {
          if(!this.value && defaultBin) {
            this.$emit('input', defaultBin.value)
          }
        })
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>